import React from 'react'
import Radium from 'radium'

import Width from '../Width'
import Totals from './Totals/index'
import Sum from './Sum'
import Reset from './Reset'

export default Radium((props) => (
  <Width>
    {({ isMedium }) => (
      <div
        style={[
          styles.container,
          isMedium && styles.medium.container,
        ]}
      >
        <Totals {...props} />
        <Sum {...props} />
        <Reset {...props} />
      </div>
    )}
  </Width>
))

const styles = {
  container: {
    width: '100%',
    maxWidth: '500px',
    marginLeft: '20px',
  },
  medium: {
    container: {
      maxWidth: 'initial',
      marginLeft: 0,
      marginTop: '30px',
    },
  },
}
